import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../mock';

const Testimonials = () => {
  return (
    <section className="py-20 bg-[#0A0F0D]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            What Brands <span className="text-[#22C55E]">Say</span>
          </h2>
          <p className="text-[#94A3B8] text-lg max-w-2xl mx-auto">
            Trusted by industry leaders who've seen real results
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div 
              key={testimonial.id}
              className="bg-[#0F172A] border border-[#22C55E]/20 rounded-xl p-8 hover:border-[#22C55E]/50 transition-all duration-300 hover:shadow-lg hover:shadow-[#22C55E]/10 animate-fade-in-up"
              style={{ animationDelay: `${index * 150}ms` }}
            >
              {/* Quote Icon */}
              <div className="mb-4">
                <Quote className="h-10 w-10 text-[#22C55E]/30" />
              </div>
              
              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="h-5 w-5 text-[#22C55E] fill-[#22C55E]" />
                ))}
              </div>
              
              {/* Content */}
              <p className="text-[#94A3B8] leading-relaxed mb-6">
                "{testimonial.content}"
              </p>
              
              {/* Author */}
              <div className="pt-4 border-t border-[#22C55E]/10">
                <p className="text-white font-semibold">{testimonial.name}</p>
                <p className="text-[#22C55E] text-sm">{testimonial.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;